export enum DatePrecision {
	Day = 'DAY',
	Exact = 'EXACT',
	Window = 'WINDOW',
	None = 'NONE',
}
